import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { Button } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { useLocation } from 'react-router-dom';
import { connect, useDispatch } from "react-redux";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import axios from "axios";
import sendbg from "../../../../assets/images/aiChat/sendbg.png";
import micOn from "../../../../assets/images/aiChat/mic_on.svg";
import micOff from "../../../../assets/images/aiChat/mic_off.svg";
import { setAiChatBotMessages } from "../../../actions/load";
import { getSettings } from "../../../actions/user";
import { CHAT_BOT_BASE_URL, AI_CHAT_BOT_BASE_URL } from "../../../constants/utils";
import BotText from "./botText";
import logo from '../../../../assets/images/acuitus-ag-logo.png';
import { getToken } from "../../../helpers/session";
import { toastError } from '../../../actions/toast';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}


const OffCanvas = (props) => {
  const dispatch = useDispatch()
  const messagesRef = useRef(null);
  const querySearchParams = useQuery();
  const from_date = querySearchParams.get('from_date');
  const to_date = querySearchParams.get('to_date');
  const farmId = querySearchParams.get('farm_uuid');
  const planTypeId = querySearchParams.get('plan_type_id');
  const userId = querySearchParams.get('user_id');
  const { aiChatMessages, actions, /* aiChatBotId */ isVertexAi, settings: { chat_bot_id } } = props;
  const [textMessage, setTextMessage] = useState("");
  const [isBotMessageLoading, setIsBotMessageLoading] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [messagePayload, setMessagePayload] = useState({})
  const {
    listening,
    resetTranscript,
    finalTranscript,
  } = useSpeechRecognition();

  useEffect(() => {
    actions.getSettings();
  }, [])

  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.scrollTo({
        top: messagesRef.current.scrollHeight,
        behavior: "smooth",
      });
    }

    // For adding all anchor tags 
    const aiChatResponseDiv = document.getElementById('aiChatResponseDiv');
    if (aiChatResponseDiv) {
      const anchors = aiChatResponseDiv.querySelectorAll('a');
      anchors.forEach(anchor => {
        anchor.setAttribute('target', '_blank');
      });
    }
  }, [aiChatMessages]);

  const errorMessageHandler = () => {
    setIsBotMessageLoading(false)
    dispatch(toastError('Something went wrong'));
  }


  useEffect(() => {
    if (finalTranscript.length) {
      resetTranscript();
      setTextMessage(finalTranscript);
      handleSendMessage('user');
    }
  }, [finalTranscript]);


  const chatStream = (payload) => {
    fetch(`${AI_CHAT_BOT_BASE_URL}/chat`,
      {
        headers: {
          'x-access-token': getToken(),
          'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify(payload)
      }
    )
      .then((response) => {
        if (response.status === 200) {
          // let message = "";
          let isFirstHistory = true
          const stream = response.body;
          const reader = stream ? stream.getReader() : null;
          const readChunk = () => {
            if (reader) {
              reader.read()
                .then(({ value, done }) => {
                  if (done) {
                    setIsBotMessageLoading(false)
                    console.log("done");
                    return;
                  } else {
                    setIsBotMessageLoading(true)
                  }
                  const chunkString = new TextDecoder().decode(value);
                  // message += chunkString;
                  // const input = 'res="{"message": "Hello! \ud83d\udc4b I\'m AcuitusAG, your personal AI data scientist for farm management. How can I help you today? \n"}\n\n{"history": [{"parts": [{"text": "hi"}], "role": "user"}, {"parts": [{"text": "Hello! \ud83d\udc4b I\'m AcuitusAG, your personal AI data scientist for farm management. How can I help you today? \n"}], "role": "model"}]}\n\n{"history": [{"parts": [{"text": "hi"}], "role": "user"}, {"parts": [{"text": "Hello! \ud83d\udc4b I\'m AcuitusAG, your personal AI data scientist for farm management. How can I help you today? \n"}], "role": "model"}]}"';

                  // Split the input string by the pattern '}\n\n{' and keep the delimiters
                  const splitStrings = chunkString.split(/(?<=})\n\n(?={)/);

                  // Add the necessary braces and parse each JSON string
                  const jsonObjects = splitStrings.map(str => {
                    // Clean the string
                    const cleanStr = str.replace(/"$/, '');
                    return JSON.parse(cleanStr);
                  });

                  if (jsonObjects.length > 0) {
                    jsonObjects.forEach((each) => {
                      const { history, message, error } = each;
                      if (message) {
                        setIsBotMessageLoading(false);
                        let md = window.markdownit();
                        let element = md.render(message);
                        const botPayload = {
                          type: "bot",
                          message: element,
                        };
                        setMessagePayload(botPayload)
                      } else if (history) {
                        if (isFirstHistory) {
                          isFirstHistory = false;
                          setChatHistory(history);
                        }
                      } else if(error) {
                        errorMessageHandler()
                      }
                    })

                  }
                  readChunk();
                })
                .catch((error) => {
                  errorMessageHandler(error)
                  console.error("Error ->", error);
                });
            }
          };
          readChunk();
        } else {
          errorMessageHandler()
          console.error("Couldn't load messages");
        }
      })
      .catch((error) => {
        errorMessageHandler()
        console.error(error);
      });

    // setInterval(() => {
    //   console.log("aiChatMessages", aiChatMessages);
    //   const botPayload = {
    //     type: "bot",
    //     message: "Interval message",
    //   };
    //   // const botMessage = [...aiChatMessages, botPayload];
    //   // setMessage(botMessage);
    //   setMessagePayload(botPayload)
    //   // actions.setAiChatBotMessages(botMessage);
    // }, [2000])
  };

  useEffect(() => {
    const botMessage = [...aiChatMessages, messagePayload];
    actions.setAiChatBotMessages(botMessage);
  }, [messagePayload])

  const handleSendMessage = async (type) => {
    if (textMessage.trim() || finalTranscript) {
      setIsBotMessageLoading(true);
      const payload = {
        type,
        message: textMessage ? textMessage : finalTranscript,
      };
      const userMessage = [...aiChatMessages, payload];
      actions.setAiChatBotMessages(userMessage);
      setTextMessage("");
      if (chat_bot_id === 4) {
        try {
          const payload = {
            // userId: aiChatBotId,
            farm_uuid: farmId,
            message: textMessage ? textMessage : finalTranscript,
            history: chatHistory,
            from_date,
            to_date,
            plan_type_id: planTypeId
          }
          chatStream(payload, userMessage);
        } catch (err) {
          console.log("Chat Error", err);
        }
      } else {
        try {
          const botResponse = await axios.post(
            `${CHAT_BOT_BASE_URL}/sendMessage`,
            {
              // userId: aiChatBotId,
              userId: userId,
              question: textMessage ? textMessage : finalTranscript,
            }
          );
          const { data } = botResponse.data;
          if (data || data === 0) {
            setIsBotMessageLoading(false);
            const botPayload = {
              type: "bot",
              message: data,
            };
            const botMessage = [...userMessage, botPayload];
            actions.setAiChatBotMessages(botMessage);
          }
        } catch (err) {
          errorMessageHandler()
          console.log("Chat Error", err);
        }
      }
    }
  };

  const startSpeech = () => {
    if (listening) {
      SpeechRecognition.stopListening();
    } else {
      SpeechRecognition.startListening({ continuous: true });
    }
  }

  const renderMessage = (messageObj, index) => {
    const { type, message } = messageObj;
    if (type === "user") {
      return (
        <div
          className="chat-message d-flex flex-row justify-content-end mb-4"
          key={index}
        >
          <div
            className="p-3 me-3 border charts_msg_text chat-text"
            style={{ borderRadius: "15px", backgroundColor: "#fbfbfb" }}
          >
            <p className="mb-0 text-preline">{message}</p>
          </div>
        </div>
      );
    } else if (type !== undefined && type === "bot" && message) {
      if (isVertexAi) {
        return (
          <div
            className="chat-message d-flex flex-row justify-content-start mb-4"
            key={index}>
            <div
              className="p-3 ms-3 charts_msg_text chat-bot-text"
              style={{
                borderRadius: "15px",
                backgroundColor: "#dce9f9",
              }}
            >
              <BotText element={message} />
            </div>
          </div>
        );
      } else {
        return (
          <div
            className="chat-message d-flex flex-row justify-content-start mb-4"
            key={index}>
            <div
              className="p-3 ms-3 user-text charts_msg_text"
              style={{
                borderRadius: "15px",
                backgroundColor: "#dce9f9",
              }}
            >
              <p className="small mb-0">{message}</p>
            </div>
          </div>
        );
      }
    }
  };


  const textbox = useRef(null);
  const adjustHeight = (isEntered) => {
    if (isEntered) {
      textbox.current.style.height = "inherit";
      textbox.current.style.height = `${textbox.current.scrollHeight}px`;
    } else {
      textbox.current.style.height = `0`;
      textbox.current.value = "";
    }
  };

  useLayoutEffect(() => {
    // textbox.current.focus()
    adjustHeight(false);
  }, []);

  const handleKeyDown = (e, condition) => {
    adjustHeight(condition);
  };

  const handleSendButton = (e) => {
    e.preventDefault();
    handleSendMessage("user")
    handleKeyDown(e, false);
  }

  return (
    <>
      <div className="chat-bot-container">
        <div className="chat-bot-header">
          <img className="chat-bot-logo" src={logo} alt="" />
        </div>
        <div className="chat-bot-body">
          <div className="card-text-box"  id='aiChatResponseDiv' ref={messagesRef}>
            {aiChatMessages &&
              aiChatMessages.length > 0 &&
              aiChatMessages.map((each, index) => {
                return renderMessage(each, index);
              })}
            {isBotMessageLoading && (
              <div className="chat-message d-flex flex-row justify-content-start mb-4">
                <div
                  className="p-3 ms-3 chat-bot-text charts_msg_text"
                  style={{
                    borderRadius: "15px",
                    backgroundColor: "#dce9f9",
                  }}
                >
                  <p className="small mb-0 chat_loading"></p>
                </div>
              </div>
            )}
          </div>

          <div className={`button-submit ${isBotMessageLoading ? 'disabled' : ''}`}>
            {/* <input
            type="text"
            className="form-control"
            label="Type your message"
            id="textAreaExample"
            placeholder="Ask your queries!"
            autoComplete="off"
            rows={4}
            value={textMessage}
            onChange={(e) => setTextMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSendMessage("user");
              }
            }}
          /> */}
            <textarea
              className={`form-control ${isBotMessageLoading ? 'disabled' : ''}`}
              label="Type your message"
              id="textAreaExample"
              placeholder="Ask your queries!"
              autoComplete="off"
              rows={1}
              value={textMessage}
              ref={textbox}
              onChange={(e) => {
                if(!isBotMessageLoading) {
                  handleKeyDown(e, true);
                  setTextMessage(e.target.value)
                }
              }}

              onKeyDown={(e) => {
                if(!isBotMessageLoading) {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleSendMessage("user");
                    handleKeyDown(e, false);
                  }
                }
              }}
            ></textarea>
            <div className="ai_action_button">
              <Button className="mic_btn" variant="" onMouseUp={() => startSpeech()} onMouseDown={() => startSpeech()}>
                <img
                  src={listening ? micOff : micOn}
                  alt="Mic"
                  style={{ height: "100%", scale: listening ? "0.9" : "1" }}
                  draggable={false}
                />
              </Button>

              <Button className="msg_send_btn" variant="" onClick={(e) => handleSendButton(e)}>
                <img
                  src={sendbg}
                  alt="avatar 1"
                  style={{ height: "100%" }}
                  draggable={false}
                />
              </Button>
            </div>
          </div>
        </div>
        <div className="chat-bot-footer">
          <p className="m-0 px-3 pb-2">Bot may display inaccurate info, so double-check its responses.</p>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ setAiChatBotMessages, getSettings }, dispatch),
});

const mapStateToProps = (state) => ({
  aiChatMessages: state.load.aiChatBotMessages,
  aiChatBotId: state.load.aiChatBotId,
  farmId: state.farm.currentFarm.farm_uuid,
  search: { range: state.analyze.searchParams },
  settings: state.user.userSettings,
});

export default connect(mapStateToProps, mapDispatchToProps)(OffCanvas);
